export class ApplicationTrustApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTrust({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/trust`);
  }

  async editTrust({ applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/trust`, body);
  }

  async deleteTrust({ applicationId, ...params }) {
    return this.#http.delete(`/application/${applicationId}/trust`, { params });
  }
}
